import { useDropDownTableStyles } from './styles/useDropDownTableStyles'

export const DropDownTableOpenReplacer = () => {
  const styles = useDropDownTableStyles()

  return <div className={styles.tableOpenReplacer} />
}
